import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import Loader from "components/Loader/index";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ModalPortal from "../../components/ModalPortal";
import MessageModal from "../../components/MessageModal";
import { CSSTransition } from "react-transition-group";
import GridWrapper from "custom-hooks/GridWrapper";
import { setApi, setData } from "reducers/grid";
import { useTranslation } from "react-i18next";
import permissions, { checkPermissions } from "config/permissions";
import { configureFilterObject } from "../../pages/Ordering/common/util/configureFilterObject";
import useDebounce from "../../custom-hooks/useDebounce";
import Diagram from "../../pages/Ordering/common/Diagram";

const mapStateToProps = (state, props) => ({});

const SearchList = props => {
    const {
        updateApiGrid,
        formValues,
        formErrors,
        query,
        allFilterFields,
        history,
        selectItemPath,
        listInit,
        entity,
        setGridData,
        onGridExport
    } = props;

    const { t } = useTranslation();

    const { hash } = props.match.params;

    const [modalEventData, setModalEventData] = useState(null);
    const [loadingState, setLoadingState] = useState(false);

    const isCanEventsView = checkPermissions(permissions.CalendarOperations.view_calendar_event);

    const { debouncedValue: debouncedFormValues, setDebouncedValue: setDebouncedFormValues } = useDebounce(
        formValues,
        300
    );

    const init = {
        ...listInit,
        extra: hash,
        query,
    };

    const gridKey = `${init.key}_${init.path || init.extra || ""}`;

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    const setOpenMode = mode => {
        if (!isCanEventsView) return;

        setModalEventData(null);
        return history.push(`${modalEventData.url}/${mode}`);
    };

    const getOpenModesForModal = () => {
        if (modalEventData && modalEventData.allowModes) {
            switch (modalEventData.allowModes.length) {
                case 2:
                    return {
                        primaryButton: true,
                        secondaryButton: true,
                        primaryButtonText: modalEventData.allowModes[0].label,
                        onClickPrimaryButton: () => setOpenMode(modalEventData.allowModes[0].code),
                        secondaryButtonText: modalEventData.allowModes[1].label,
                        onClickSecondaryButton: () => setOpenMode(modalEventData.allowModes[1].code),
                    };
                case 3:
                    return {
                        dangerButton: true,
                        primaryButton: true,
                        secondaryButton: true,
                        primaryButtonText: modalEventData.allowModes[0].label,
                        onClickPrimaryButton: () => setOpenMode(modalEventData.allowModes[0].code),
                        secondaryButtonText: modalEventData.allowModes[1].label,
                        onClickSecondaryButton: () => setOpenMode(modalEventData.allowModes[1].code),
                        dangerButtonText: modalEventData.allowModes[2].label,
                        onClickDangerButton: () => setOpenMode(modalEventData.allowModes[2].code),
                    };
            }
        }
    };

    const tryToUpdateApiGrid = (api, gridKey) => {
        if (isEmpty(formErrors)) {
            updateApiGrid(api, gridKey);
        }
    }

    const getParams = () => {
        const params = {
            selectItem: item => {
                if (entity === "clevent") {
                    if (!isCanEventsView) return;

                    if (item.allowModes && item.allowModes.length > 1) {
                        return setModalEventData({
                            url: init.url,
                            allowModes: init.allowModes,
                        });
                    }
                    return history.push(`${item.url}/${item.allowModes[0].code}`);
                }

                if (entity === "task") {
                    return history.push(`/order/${item.id}`);
                }

                if (entity === "spec") {
                    return history.push(`/service/${item.id}`);
                }
                if (entity === "appeal") {
                    return history.push(`/appeals/${item.id}`);
                }
                if (entity === "contact_person") {
                    return history.push(`/customer/${item.customerId}/person/${item.id}/contact`);
                }

                return history.push(`/${selectItemPath}/${item.id}`);
            },
        };
        if (entity === "task") {
            params.fields = {
                hasFlow: { component: Diagram },
            };
        }
        return params;
    };

    useEffect(() => {
        if (debouncedFormValues && allFilterFields && !loadingState) {
            const filterObject = configureFilterObject(debouncedFormValues || {}, allFilterFields) || [];
            tryToUpdateApiGrid({ query, filterObject }, gridKey);
        }
    }, [debouncedFormValues, query]);

    useEffect(() => {
        if (allFilterFields && !loadingState) {
            const filterObject = configureFilterObject(formValues || {}, allFilterFields) || [];
            tryToUpdateApiGrid({ start: 0, query, filterObject }, gridKey);
        }
    }, [hash]);

    useEffect(() => {
        if (!isEmpty(formErrors)) {
            setGridData({ result: [], total: 0, success: true, }, gridKey);
        }
    }, [formErrors]);

    return (
        <>
            <div className="content-wrapper ordering-component-ui-core-wrapper with-fixed-status customer-ordering-grid">
                <div className="content-wrapper">
                    {loadingState && <Loader />}
                    <GridWrapper
                        tuner={() => init}
                        gridParams={getParams()}
                        initUpdate={false}
                        onStart={onStart}
                        onFinish={onFinish}
                        onGridExport={onGridExport}
                        fieldsLsCacheKey={`search_tab_${gridKey}`}
                    />
                </div>
            </div>
            <CSSTransition
                in={modalEventData}
                classNames="fade"
                appear
                enter
                exit
                timeout={300}
                mountOnEnter
                unmountOnExit
            >
                <ModalPortal onClose={() => setModalEventData(null)} className="modal-small modal-center">
                    <MessageModal
                        titleModal={t("calendar.askEventModalTitle")}
                        contentModalText={t("calendar.askEventModalDescription")}
                        {...getOpenModesForModal()}
                    />
                </ModalPortal>
            </CSSTransition>
        </>
    );
};

export default withRouter(connect(mapStateToProps, { updateApiGrid: setApi, setGridData: setData })(SearchList));
